import * as React from "react";
import PropTypes from "prop-types";
import Backbone from "backbone";
import parseIconsFromServer from "nexia_mobile/parseIconsFromServer";
import DetailsHeaderWrapper, {
  DetailsHeaderOffscreenOverscroll,
} from "nexia_mobile/components/Details/DetailsHeaders/DetailsHeaderWrapper";
import IconGroup from "nexia_mobile/components/IconGroup";
import DrawUpdates from "nexia_mobile/components/DrawUpdates";

export default class AutomationHeader extends React.Component {
  static propTypes = {
    model: PropTypes.instanceOf(Backbone.Model).isRequired,
  };

  render() {
    const { model } = this.props;

    const icons = parseIconsFromServer(model.get("icon"));
    const styles = {
      statusIcon: {
        fontSize: "4em",
        margin: "0", // override default margin
        verticalAlign: "middle",
      },
      statusDescription: {
        display: "block",
        padding: ".5em",
        paddingTop: "1em",
        whiteSpace: "normal",
      },
    };

    return (
      <React.Fragment>
        <DrawUpdates
          listenTo={model}
          events={["change"]}
          getNodeToStyle={() => this._wrapper}
        />
        <div data-component-name="AutomationHeader">
          <DetailsHeaderOffscreenOverscroll />
          <DetailsHeaderWrapper innerRef={(el) => (this._wrapper = el)}>
            <IconGroup values={icons} disableBadges style={styles.statusIcon} />
            <div
              data-component-section="description"
              style={styles.statusDescription}
            >
              {model.get("description")}
            </div>
          </DetailsHeaderWrapper>
        </div>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Details/DetailsHeaders/AutomationHeader.jsx